import React, { memo, useCallback, useEffect, useState } from 'react';

import { SearchItem } from 'src/components/main/quiz/hometown-step/components/search-item';

import SearchLoupe from '../../../../../../assets/images/quiz/search-loupe.svg';
import styles from './search-result.module.scss';

type tpCities = tpCity[] | null;

export type tpCity = {
  geometry: {
    coordinates: [number, number];
  };
  properties: {
    name: string;
    country: string;
    state: string;
    osm_id: number;
  };
};

export const SearchResult = memo(
  ({
    debouncedValue,
    handleSelect,
  }: {
    debouncedValue: string;
    handleSelect: (value: string, latitude: number, longitude: number) => void;
  }) => {
    const [cities, setCities] = useState<tpCities>(null);
    const [isLoading, setIsLoading] = useState(false);
    const hasMinimumLength = debouncedValue.length >= 2;

    const getCities = useCallback(async (city: string) => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `https://nominatim.mentalgrowth.app/api?q=${city}&layer=city&limit=8`,
        );
        const data = await response.json();
        setCities(data.features);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }, []);

    useEffect(() => {
      if (hasMinimumLength) {
        getCities(debouncedValue).then((r) => r);
      }
    }, [debouncedValue, getCities, hasMinimumLength]);

    if (!hasMinimumLength) {
      return null;
    }

    if (isLoading || cities === null) {
      return (
        <svg
          className={styles.loader}
          viewBox="-10 -12 32 32"
          xmlns="http://www.w3.org/2000/svg">
          <svg
            id="enBXAMuiL9K1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32">
            <ellipse
              rx="4.2"
              ry="4.2"
              transform="translate(6 6)"
              fill="#a6a1c5"
            />
            <g id="enBXAMuiL9K3_to" transform="translate(7.6,16)">
              <ellipse rx="4.2" ry="4.2" fill="#181926" />
              <animateTransform
                id="first"
                attributeName="transform"
                attributeType="XML"
                type="translate"
                begin="0s;second.end"
                dur="1.5s"
                from="2 6"
                to="10 6"
              />
              <animateTransform
                id="second"
                attributeName="transform"
                attributeType="XML"
                type="translate"
                begin="first.end"
                dur="1.5s"
                from="10 6"
                to="2 6"
              />
            </g>
          </svg>
        </svg>
      );
    }

    if (cities.length === 0 && !isLoading) {
      return (
        <div className={styles.nothingFound}>
          <SearchLoupe />
          <p>Nothing was found</p>
        </div>
      );
    }
    return (
      <ul className={styles.citiesContainer}>
        {cities.map((city: tpCity) => (
          <SearchItem
            city={city}
            key={city.properties.osm_id}
            onClick={() => {
              handleSelect(
                `${city.properties.name}, ${
                  city.properties.state ? city.properties.state + ', ' : ''
                }${city.properties.country}`,
                city.geometry.coordinates[1],
                city.geometry.coordinates[0],
              );
            }}
          />
        ))}
      </ul>
    );
  },
);
SearchResult.displayName = 'SearchResult';
